module.exports = __webpack_public_path__ + "img/kaihui.a52b925b.png";